import { useState, useEffect } from 'react';
import { authAPI } from '../services/api';

let cachedFlags: { viyonaEnabled: boolean; poolpayEnabled: boolean } | null = null;

/**
 * Hook to get merchant payout visibility flags (Viyona, PoolPay).
 * Used to filter Create Payout options in merchant sidebar.
 * Caches result for the session to avoid duplicate profile fetches.
 */
export function useMerchantPayoutFlags() {
  const [flags, setFlags] = useState({
    viyonaEnabled: true,
    poolpayEnabled: true
  });

  useEffect(() => {
    if (cachedFlags) {
      setFlags(cachedFlags);
      return;
    }
    authAPI
      .getProfile()
      .then((res) => {
        const d = res.data?.data;
        const f = {
          viyonaEnabled: d?.viyona_enabled !== false && d?.viyona_enabled !== 0,
          poolpayEnabled: d?.poolpay_enabled !== false && d?.poolpay_enabled !== 0
        };
        cachedFlags = f;
        setFlags(f);
      })
      .catch(() => {
        // Default to both enabled on error
      });
  }, []);

  return flags;
}
